/* DTA-reg-mark.js — stellt ® im Seitentext hoch
 *
 * Kelson (Standard-Font) zeichnet ® in voller Größe auf der Grundlinie. Ein einzelnes
 * Zeichen lässt sich per CSS nicht ansteuern, daher wird jedes ® in Textknoten in
 * <sup class="dta-reg">®</sup> gepackt (Styling in DTA-styles.css).
 * Fonts mit bereits hochgestelltem ®-Glyph (Barlow, Inter) bleiben unangetastet,
 * sonst würde das Zeichen doppelt verkleinert.
 *
 * Attribute (title, alt, aria-label, Meta-Tags) bleiben unberührt — dort ist nur Text erlaubt.
 * Nachgeladene Inhalte (Cart-Drawer, Theme-Editor) erfasst ein MutationObserver.
 */
(function () {
  if (window.DTARegMark) return;

  var CHAR = '®';
  var SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SELECT|OPTION|SUP|TITLE)$/;
  var NATIVE_SUP_FONT = /^\s*["']?(Barlow|Inter)["',\s]/i;

  function skip(node) {
    var parent = node.parentNode;
    for (var el = parent; el && el.nodeType === 1; el = el.parentNode) {
      if (SKIP.test(el.nodeName) || el.isContentEditable) return true;
      // HTML in <foreignObject> (z.B. button-007 Hover-Text) ist normaler Text,
      // reiner SVG-Text (<text>, <svg>) darf kein <sup> bekommen
      if (el.nodeName === 'foreignObject') break;
      if (el.nodeName === 'svg' || el.nodeName === 'text') return true;
    }
    return NATIVE_SUP_FONT.test(getComputedStyle(parent).fontFamily + ',');
  }

  function wrap(textNode) {
    var parts = textNode.nodeValue.split(CHAR);
    var frag = document.createDocumentFragment();
    parts.forEach(function (part, i) {
      if (part) frag.appendChild(document.createTextNode(part));
      if (i < parts.length - 1) {
        var sup = document.createElement('sup');
        sup.className = 'dta-reg';
        sup.textContent = CHAR;
        frag.appendChild(sup);
      }
    });
    // Immer Text + ® gemeinsam in ein <span>: In Flex-/Grid-Containern würde das <sup>
    // sonst ein eigenes Item (gap davor, vertical-align wirkungslos). Nicht per
    // getComputedStyle prüfbar, da [hidden]-Elemente dort display: none melden.
    var span = document.createElement('span');
    span.className = 'dta-reg-wrap';
    span.appendChild(frag);
    textNode.parentNode.replaceChild(span, textNode);
  }

  function scan(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      if (root.nodeValue.indexOf(CHAR) !== -1 && root.parentNode && !skip(root)) wrap(root);
      return;
    }
    if (root.nodeType !== 1 && root.nodeType !== 11) return;
    if (root.nodeType === 1 && SKIP.test(root.nodeName)) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        return n.nodeValue.indexOf(CHAR) !== -1 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var hits = [];
    while (walker.nextNode()) hits.push(walker.currentNode);
    hits.forEach(function (n) {
      if (n.parentNode && !skip(n)) wrap(n);
    });
  }

  var pending = [];
  var queued = false;
  function flush() {
    queued = false;
    var nodes = pending;
    pending = [];
    nodes.forEach(scan);
  }

  function init() {
    scan(document.body);
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        if (r.type === 'characterData') pending.push(r.target);
        else r.addedNodes.forEach(function (n) { pending.push(n); });
      });
      if (pending.length && !queued) {
        queued = true;
        requestAnimationFrame(flush);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  window.DTARegMark = { refresh: function () { scan(document.body); } };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
